import React from "react";

interface LoadMoreToggleProps {
  /** How many items are currently visible. */
  visible: number;
  /** Total number of items available. */
  total: number;
  /** Increment / reset step (defaults to 10). */
  step?: number;
  /** Called with the next visible count. */
  onChange: (next: number) => void;
}

const linkStyle: React.CSSProperties = {
  color: "#F26522",
  cursor: "pointer",
  fontSize: "14px",
};

/** "View more" / "View less" toggle shown under a file list/grid. */
const LoadMoreToggle = ({
  visible,
  total,
  step = 10,
  onChange,
}: LoadMoreToggleProps) => (
  <div className="mt-2">
    {visible < total ? (
      <span
        onClick={() => onChange(visible + step)}
        style={linkStyle}
        className="mUIrbf-vQzf8d"
      >
        View more
      </span>
    ) : (
      total > step && (
        <span
          onClick={() => onChange(step)}
          style={linkStyle}
          className="mUIrbf-vQzf8d"
        >
          View less
        </span>
      )
    )}
  </div>
);

export default LoadMoreToggle;
